import React, {useEffect, useState} from 'react';
import {Box, Button, Pagination} from 'adminlte-2-react';
import {DataTable} from 'primereact/datatable';
import {Modal} from 'react-bootstrap';
import {Column} from 'primereact/column';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {
  getDateWithFormat,
  toTitleCase,
  openWhatsapp,
  responseSelector,
} from '../utils/utils';
import Etiqueta from '../utils/etiquetaObligatorio/Etiqueta';
import {CheckBox} from '../ui/Checkbox';
import {MonedaInputV2} from '../ui/moneda';
import {Alert, alertTypes, useAlerts} from '../ui/alert';
import {CargosPotencialesNotas} from './editar/CargosPotencialesNotas';
import {EditarNotaView} from './EditarNotaView';
import {useDispatch, useSelector} from 'react-redux';
import {
  deleteNotaDuck,
  deleteNotaThunk,
  getNotasDuck,
  getNotasThunk,
  notaFavoritaSetDuck,
  notaFavoritaSetThunk,
} from './duck';
const {TextInput} = require('../utils/TextInput');

function ModalNotasV2({
  isModalShown,
  hideModal,
  showModal,
  handlePage,
  userIdNumerico,
  getNotaFavorita,
  candidatoIdNumerico,
  token,
  oportunidadId,
}) {
  const notaFavoritaSet = useSelector(state => state.notaFavoritaSet);
  const modelNotas = useSelector(state => state.getNotas);
  const modelDeleteNota = useSelector(state => state.deleteNota);

  const [notaSelected, setNotaSelected] = useState();
  const [notas, setNotas] = useState([]);
  const [totalResultsNotas, setTotalResultsNotas] = useState(0);
  const [activePageNotas, setActivePageNotas] = useState(0);
  const pageSizeNotas = 5;

  const [showInputs, setShowInputs] = useState(null);
  const [showAlertBorrar, setShowAlertBorrar] = useState(null);
  const [selected, setSelected] = useState(null);
  const title = showAlertBorrar ? 'Alerta' : 'Notas del candidato';
  const {setTopAlert, topAlert} = useAlerts();
  const dispatch = useDispatch();
  function setearNotaFavorita({notaIdNumerico, candidatoIdNumerico, setear}) {
    dispatch(
      notaFavoritaSetThunk({
        userToken: token.raw,
        notaIdNumerico,
        candidatoIdNumerico,
        setear,
      }),
    );
  }

  useEffect(() => {
    const {httpStatus, error, errorMessage} = responseSelector(notaFavoritaSet);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });
      dispatch(notaFavoritaSetDuck.actions.clear());
    }

    if (httpStatus) {
      handlePageNotas(activePageNotas);
      if (handlePage) {
        handlePage(0);
      }
      if (getNotaFavorita) {
        getNotaFavorita();
      }
      dispatch(notaFavoritaSetDuck.actions.clear());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notaFavoritaSet]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelNotas);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getNotasDuck.actions.clear());
    }

    if (data) {
      setNotas(data.items);
      setTotalResultsNotas(data.total);

      dispatch(getNotasDuck.actions.clear());
    }
  }, [modelNotas]);

  function handlePageNotas(page) {
    setActivePageNotas(page);

    setNotas([]);

    const params = {
      page: page + 1,
      limit: pageSizeNotas,
      candidatoIdNumerico,
    };

    dispatch(
      getNotasThunk({
        ...params,
        userToken: token.raw,
      }),
    );
  }

  useEffect(() => {
    handlePageNotas(0);
  }, [candidatoIdNumerico]);

  function deleteNota(idNumerico, creacionUsuario) {
    setTopAlert({
      title: null,
      text: null,
      type: null,
      closable: false,
    });

    dispatch(
      deleteNotaThunk({
        userToken: token.raw,
        candidatoIdNumerico,
        idNumerico: idNumerico,
        creacionUsuario: creacionUsuario,
      }),
    );
  }

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelDeleteNota);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });
      handlePageNotas(0);
      dispatch(deleteNotaDuck.actions.clear());
    }
    if (data) {
      handlePageNotas(0);
      if (handlePage) {
        handlePage(0);
      }

      setTopAlert({
        text: 'Nota eliminada correctamente',
        type: alertTypes.success,
        closable: false,
      });

      dispatch(deleteNotaDuck.actions.clear());
    }
  }, [modelDeleteNota]);

  return (
    <Modal
      show={isModalShown}
      style={{opacity: 1}}
      onHide={() => {
        hideModal();
        setShowInputs(false);
        setShowAlertBorrar(false);
      }}
      onShow={showModal}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {topAlert?.text && (
          <Alert
            title={topAlert.title}
            type={topAlert.type}
            text={topAlert.text}
            closable={topAlert.closable}
          />
        )}

        {showAlertBorrar ? (
          'Esta seguro que desea borrar la nota?'
        ) : (
          <div style={{marginBottom: 10}}>
            {!showInputs && (
              <Button
                pullRight
                type="primary"
                text="Agregar nota"
                size="sm"
                onClick={() => {
                  setNotaSelected('');
                  setShowInputs(true);
                }}
              />
            )}
            <br />
            {showInputs && (
              <EditarNotaView
                setTopAlert={setTopAlert}
                notaSelected={notaSelected}
                setNotaSelected={setNotaSelected}
                token={token}
                candidatoIdNumerico={candidatoIdNumerico}
                setShowInputs={setShowInputs}
                oportunidadId={oportunidadId}
                handlePageNotas={handlePageNotas}
                handlePage={handlePage}
              />
            )}
            {!showInputs && (
              <div style={{marginTop: 10}}>
                {notas && notas.length > 0 ? (
                  <Box noPadding={true} border={false} style={{borderTop: 0}}>
                    <div className="table-responsive">
                      <DataTable
                        lazy
                        pt={{
                          table: {
                            className: 'table table-hover',
                          },
                        }}
                        value={notas}
                        emptyMessage="No se encontraron registros">
                        <Column
                          field="contenido"
                          header="Notas"
                          body={nota => {
                            return (
                              <>
                                <strong>
                                  Fecha: {getDateWithFormat(nota.creacionTs)}
                                </strong>{' '}
                                -
                                <strong>
                                  De: {nota.creacionUsuarioNombre}
                                </strong>
                                <ButtonWithLoading
                                  pullRight
                                  type={nota.destacado ? 'success' : 'default'}
                                  icon="fa-star"
                                  margin
                                  size="sm"
                                  submit={() => {
                                    setearNotaFavorita({
                                      notaIdNumerico: nota.idNumerico,
                                      candidatoIdNumerico:
                                        nota.candidatoIdNumerico,
                                      setear: !nota.destacado,
                                    });
                                  }}
                                  loading={notaFavoritaSet.loading}
                                />
                                {nota.creacionUsuario === userIdNumerico && (
                                  <Button
                                    pullRight
                                    type="danger"
                                    icon="fa-trash"
                                    size="sm"
                                    margin
                                    onClick={() => {
                                      setSelected({
                                        idNumerico: nota.idNumerico,
                                        creacionUsuario: nota.creacionUsuario,
                                      });
                                      setShowAlertBorrar(true);
                                    }}
                                  />
                                )}
                                {(nota.creacionUsuario === userIdNumerico ||
                                  nota.destacado) && (
                                  <Button
                                    pullRight
                                    type="default"
                                    icon="fa-edit"
                                    margin
                                    size="sm"
                                    onClick={() => {
                                      setNotaSelected(nota);
                                      setShowInputs(true);
                                    }}
                                  />
                                )}
                                <br />
                                <strong>{nota.titulo}</strong>
                                <br />
                                <p>{nota.contenido}</p>
                              </>
                            );
                          }}></Column>
                      </DataTable>
                    </div>
                  </Box>
                ) : (
                  <p className="text-muted">No se han encontrado notas</p>
                )}
              </div>
            )}

            {!showInputs && notas && notas.length > 0 && (
              <Pagination
                activePage={activePageNotas}
                pageSize={pageSizeNotas}
                totalElements={totalResultsNotas}
                onChange={handlePageNotas}
                labels={{
                  first: 'Primera',
                  last: 'Última',
                  previous: 'Anterior',
                  next: 'Siguiente',
                }}
              />
            )}
          </div>
        )}
      </Modal.Body>

      {showAlertBorrar && (
        <Modal.Footer>
          <ButtonWithLoading
            type="danger"
            text={'Eliminar'}
            submit={() => {
              deleteNota(selected.idNumerico, selected.creacionUsuario);
              setShowAlertBorrar(false);
            }}
          />
        </Modal.Footer>
      )}
    </Modal>
  );
}

export {ModalNotasV2};
